import { styled } from '../jss-style';
import inputStyle from './input';

const useInputStyle = styled(inputStyle, 'input');
export { inputStyle, useInputStyle };
export default useInputStyle;
